import React from 'react'
import { FiX } from 'react-icons/fi'
import Modal from 'react-modal'

interface ModalProps {
  isOpen: boolean
  onRequestClose: () => void
}

/*
 *** COMO CRIAR UM MODAL ***
 * 1º: Crie um state na pagina:
 * const [isModalOpen, setIsModalOpen] = useState(false)
 *
 * 2º: crie uma função para fechar o modal na página:
 * function handleCloseModal(): void {
 *  setIsModalOpen(false)
 * }
 *
 * 3º: Crie o componente (possui children!):
 * <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
 *
 * 4º: Seja feliz :D
 */

const ModalBox: React.FC<ModalProps> = ({
  isOpen,
  onRequestClose,
  children,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content modal-content-image"
    >
      <FiX onClick={onRequestClose} />
      <div
        style={{
          maxHeight: '80vh',
          overflow: 'auto',
          scrollbarWidth: 'thin',
        }}
      >
        {children}
      </div>
    </Modal>
  )
}

export default ModalBox
